import { render, staticRenderFns } from "./sewageMonitorDetail.vue?vue&type=template&id=18c919c4&scoped=true&"
import script from "./sewageMonitorDetail.vue?vue&type=script&lang=js&"
export * from "./sewageMonitorDetail.vue?vue&type=script&lang=js&"
import style0 from "./sewageMonitorDetail.vue?vue&type=style&index=0&id=18c919c4&scoped=true&lang=css&"
import style1 from "./sewageMonitorDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c919c4",
  null
  
)

export default component.exports